import type { Vob } from '@finpay-estimation/estimation-types';

import { apiRequest } from './http-client';
import { withVobPlanCodeAsString } from './vob-plan-code';

export async function saveVob(
  apiBase: string,
  authToken: string,
  vob: Vob
): Promise<Vob> {
  const payload = withVobPlanCodeAsString(vob);
  const response = await apiRequest<Vob>(apiBase, '/vob/v3/vob', {
    method: 'POST',
    body: payload,
    authToken,
  });

  if (response.hasErrors || !response.entity) {
    throw new Error(response.errorMessage ?? 'Failed to save VOB');
  }

  return response.entity;
}
